import Validators from 'redux-form-validators'

Object.assign(Validators.messages, {
  presence: 'فیلد اجباری',
})



// WEBPACK FOOTER //
// ./src/initialize.js